import React, { Component } from "react";
import {
  Button,
  Container,
  Row, Form,
  Col,
  Offcanvas,
} from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from '../config.json';

import LoadingOverlay from "./LoadingOverlay";
export default class Attendees extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      errors: {},
      filteredData: null,
      tableClms: [
        {
          name: "S.NO",
          selector: (row, i) => row.attendees_Id,
          sortable: true,
          cell: (row) => <span>{row.attendees_Id}</span>,
        },
        { name: "Attendee Id", selector: (row, i) => row.attendId, sortable: true, cell: (row) => <span>{row.attendId}</span>, }, { name: "Meeting Id", selector: (row, i) => row.meetingId, sortable: true, cell: (row) => <span>{row.meetingId}</span>, }, { name: "Event Id", selector: (row, i) => row.eventId, sortable: true, cell: (row) => <span>{row.eventId}</span>, }, { name: "Clientattendee Id", selector: (row, i) => row.clientattendeeId, sortable: true, cell: (row) => <span>{row.clientattendeeId}</span>, }, { name: "Ourattendee Id", selector: (row, i) => row.ourattendeeId, sortable: true, cell: (row) => <span>{row.ourattendeeId}</span>, }, { name: "Dummy One", selector: (row, i) => row.dummyOne, sortable: true, cell: (row) => <span>{row.dummyOne}</span>, }, { name: "Dummy Two", selector: (row, i) => row.dummyTwo, sortable: true, cell: (row) => <span>{row.dummyTwo}</span>, }, { name: "Dummy Three", selector: (row, i) => row.dummyThree, sortable: true, cell: (row) => <span>{row.dummyThree}</span>, }, { name: "Dummy Four", selector: (row, i) => row.dummyFour, sortable: true, cell: (row) => <span>{row.dummyFour}</span>, }, { name: "Dummy Five", selector: (row, i) => row.dummyFive, sortable: true, cell: (row) => <span>{row.dummyFive}</span>, },
        //***tableClms
        {
          name: "Actions",
          sortable: false,
          cell: (row) => (
            <div>
              {/* edit button and delete button */}
              <Button
                style={{ marginRight: "10px" }}
                variant="primary"
                onClick={() => this.AttendeeseditHandler(row)}
                className="bi bi-pen"
              >
              </Button>
              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              >
              </Button>
            </div>
          ),
        },
      ],
      currentPage: 1,
      itemsPerPage: 10,
      isEditing: false,
      attendees_Id: "",
      attendId: '', meetingId: '', eventId: '', clientattendeeId: '', ourattendeeId: '', dummyOne: '', dummyTwo: '', dummyThree: '', dummyFour: '', dummyFive: '',
      //***state
    };
  }
  // offcanvas Open
  handleOffcanvasShow = () => {
    this.setState({ show: true, attendId: '', meetingId: '', eventId: '', clientattendeeId: '', ourattendeeId: '', dummyOne: '', dummyTwo: '', dummyThree: '', dummyFour: '', dummyFive: '', });
  };
  // Offcanvas close button
  handleOffcanvasClose = () => {
    this.setState({ show: false, isEditing: false, attendId: '', meetingId: '', eventId: '', clientattendeeId: '', ourattendeeId: '', dummyOne: '', dummyTwo: '', dummyThree: '', dummyFour: '', dummyFive: '', });
  };
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg); // 'warn' is used instead of 'warning'
        break;
      default:
        toast.info(msg);
    }
  };
  AttendeeseditHandler = (row) => {
    // e.preventDefault();
    this.setState({
      isEditing: true, attendees_Id: row.attendees_Id, attendId: row.attendId, meetingId: row.meetingId, eventId: row.eventId, clientattendeeId: row.clientattendeeId, ourattendeeId: row.ourattendeeId, dummyOne: row.dummyOne, dummyTwo: row.dummyTwo, dummyThree: row.dummyThree, dummyFour: row.dummyFour, dummyFive: row.dummyFive, //***editstate
    });
  }

  AttendeesfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + 'C_Attendees/list', {  // Enter your IP address here

      method: 'POST',
      //headers :{ 'Content-Type' : 'application/json'},
      mode: 'cors',
      body: formData// body data type must match "Content-Type" header
    }).then(response => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        }
      });
  }
  AttendeessubmitHandler = (e) => {
    e.preventDefault();
    //   setButtons(contacts);
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append('attendId', this.state.attendId);
    formData.append('meetingId', this.state.meetingId);
    formData.append('eventId', this.state.eventId);
    formData.append('clientattendeeId', this.state.clientattendeeId);
    formData.append('ourattendeeId', this.state.ourattendeeId);
    formData.append('dummyOne', this.state.dummyOne);
    formData.append('dummyTwo', this.state.dummyTwo);
    formData.append('dummyThree', this.state.dummyThree);
    formData.append('dummyFour', this.state.dummyFour);
    formData.append('dummyFive', this.state.dummyFive);

    //***tableData*
    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + 'C_Attendees/add', {  // Enter your IP address here

      method: 'POST',
      //headers :{ 'Content-Type' : 'application/json'},
      mode: 'cors',
      body: formData// body data type must match "Content-Type" header
    }).then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.AttendeesfetchHandler();
          this.handleOffcanvasClose();
          this.setState({ attendId: '', meetingId: '', eventId: '', clientattendeeId: '', ourattendeeId: '', dummyOne: '', dummyTwo: '', dummyThree: '', dummyFour: '', dummyFive: '', });
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  }
  AttendeesupdateHandler = (e) => {
    e.preventDefault();
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("attendees_Id", this.state.attendees_Id);
    formData.append('attendId', this.state.attendId);
    formData.append('meetingId', this.state.meetingId);
    formData.append('eventId', this.state.eventId);
    formData.append('clientattendeeId', this.state.clientattendeeId);
    formData.append('ourattendeeId', this.state.ourattendeeId);
    formData.append('dummyOne', this.state.dummyOne);
    formData.append('dummyTwo', this.state.dummyTwo);
    formData.append('dummyThree', this.state.dummyThree);
    formData.append('dummyFour', this.state.dummyFour);
    formData.append('dummyFive', this.state.dummyFive);

    //***tableData1
    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + 'C_Attendees/update', {
      method: 'POST',
      mode: 'cors',
      body: formData
    }).then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.AttendeesfetchHandler();
          this.handleOffcanvasClose();
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  }

  componentDidMount() {
    this.AttendeesfetchHandler();

    //***componentDidMount
  }
  handleattendIdChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ attendId: fieldValue });
  }; handlemeetingIdChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ meetingId: fieldValue });
  }; handleeventIdChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ eventId: fieldValue });
  }; handleclientattendeeIdChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ clientattendeeId: fieldValue });
  }; handleourattendeeIdChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ ourattendeeId: fieldValue });
  }; handledummyOneChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyOne: fieldValue });
  }; handledummyTwoChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyTwo: fieldValue });
  }; handledummyThreeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyThree: fieldValue });
  }; handledummyFourChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyFour: fieldValue });
  }; handledummyFiveChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyFive: fieldValue });
  };
  //***inputFunctions
  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };
  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];
    const index = oldData.index;
    data[index] = newData;
    this.setState({ data });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);
    // implement your edit logic here
  };
  handleDelete = (row, index) => {
    var formData = new FormData();
    formData.append('attendees_Id', row.attendees_Id);
    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + 'C_Attendees/delete', {
      method: 'POST',
      mode: 'cors',
      body: formData
    }).then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.AttendeesfetchHandler();
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  };
  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };

  render() {
    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      )
      : this.state.data.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      );

    return (
      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div
                  id="datatable_wrapper"
                  className="dataTables_wrapper form-inline
                dt-bootstrap no-footer"
                >
                  <Row className="row">
                    <div>
                      <h3 className="logoskybluecolor" style={{ textAlign: "start" }}>Attendees</h3>
                    </div>
                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "5px", marginTop: "20px" }}
                    >
                      <Button
                        variant="primary" style={{ float: "right", marginBottom: "10px" }}
                        className="bi bi-plus "
                        onClick={this.handleOffcanvasShow}
                      >
                        New
                      </Button>
                      <Offcanvas
                        show={this.state.show}
                        onHide={this.handleOffcanvasClose}
                        {...this.props}
                        style={{ width: "500px" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>Add Attendees</Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <Container style={{ "overflowY": "auto", height: "auto" }}>
                            <Row className="divstyle">
                              <Row>
                                <Form>
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Attendee Id</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleattendIdChange} className="form-control" name="attendId" value={this.state.attendId} required="required" placeholder="Enter Attendee Id" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.attendId} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Meeting Id</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlemeetingIdChange} className="form-control" name="meetingId" value={this.state.meetingId} required="required" placeholder="Enter Meeting Id" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.meetingId} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Event Id</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleeventIdChange} className="form-control" name="eventId" value={this.state.eventId} required="required" placeholder="Enter Event Id" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.eventId} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Clientattendee Id</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleclientattendeeIdChange} className="form-control" name="clientattendeeId" value={this.state.clientattendeeId} required="required" placeholder="Enter Clientattendee Id" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.clientattendeeId} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Ourattendee Id</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleourattendeeIdChange} className="form-control" name="ourattendeeId" value={this.state.ourattendeeId} required="required" placeholder="Enter Ourattendee Id" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.ourattendeeId} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Dummy One</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handledummyOneChange} className="form-control" name="dummyOne" value={this.state.dummyOne} required="required" placeholder="Enter Dummy One" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyOne} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Dummy Two</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handledummyTwoChange} className="form-control" name="dummyTwo" value={this.state.dummyTwo} required="required" placeholder="Enter Dummy Two" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyTwo} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Dummy Three</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handledummyThreeChange} className="form-control" name="dummyThree" value={this.state.dummyThree} required="required" placeholder="Enter Dummy Three" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyThree} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Dummy Four</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handledummyFourChange} className="form-control" name="dummyFour" value={this.state.dummyFour} required="required" placeholder="Enter Dummy Four" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyFour} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Dummy Five</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handledummyFiveChange} className="form-control" name="dummyFive" value={this.state.dummyFive} required="required" placeholder="Enter Dummy Five" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyFive} </div>
                                  </Row><br />
                                  {/* tableContent */}
                                </Form>
                              </Row>
                            </Row>
                            <Row>
                              <Col
                                className="d-flex justify-content-end"
                                style={{ marginRight: "50px" }}
                              >
                                <Button
                                  className="button"
                                  variant="success"
                                  onClick={this.AttendeessubmitHandler}
                                  style={{
                                    marginTop: "20px",
                                  }}
                                >
                                  Save
                                </Button>
                              </Col>
                            </Row>
                          </Container>
                        </Offcanvas.Body>
                      </Offcanvas>
                      {this.state.isEditing && (
                        // Edit Offcanvas
                        <Offcanvas
                          show={this.state.isEditing}
                          // onHide={() => this.setState({ isEditing: false })}
                          onHide={this.handleOffcanvasClose}
                          {...this.props}
                          style={{ width: "500px" }}
                          placement="end"
                          backdrop="true"
                        >
                          <Offcanvas.Header closeButton>
                            <Offcanvas.Title>Edit Attendees</Offcanvas.Title>
                          </Offcanvas.Header>
                          <Offcanvas.Body>
                            <Container style={{ "overflowY": "auto", height: "auto" }}>
                              <Row className="divstyle">
                                <Row>
                                  <Form>
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Attendee Id</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleattendIdChange} className="form-control" name="attendId" value={this.state.attendId} required="required" placeholder="Enter Attendee Id" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.attendId} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Meeting Id</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlemeetingIdChange} className="form-control" name="meetingId" value={this.state.meetingId} required="required" placeholder="Enter Meeting Id" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.meetingId} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Event Id</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleeventIdChange} className="form-control" name="eventId" value={this.state.eventId} required="required" placeholder="Enter Event Id" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.eventId} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Clientattendee Id</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleclientattendeeIdChange} className="form-control" name="clientattendeeId" value={this.state.clientattendeeId} required="required" placeholder="Enter Clientattendee Id" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.clientattendeeId} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Ourattendee Id</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleourattendeeIdChange} className="form-control" name="ourattendeeId" value={this.state.ourattendeeId} required="required" placeholder="Enter Ourattendee Id" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.ourattendeeId} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Dummy One</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handledummyOneChange} className="form-control" name="dummyOne" value={this.state.dummyOne} required="required" placeholder="Enter Dummy One" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyOne} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Dummy Two</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handledummyTwoChange} className="form-control" name="dummyTwo" value={this.state.dummyTwo} required="required" placeholder="Enter Dummy Two" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyTwo} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Dummy Three</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handledummyThreeChange} className="form-control" name="dummyThree" value={this.state.dummyThree} required="required" placeholder="Enter Dummy Three" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyThree} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Dummy Four</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handledummyFourChange} className="form-control" name="dummyFour" value={this.state.dummyFour} required="required" placeholder="Enter Dummy Four" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyFour} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Dummy Five</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handledummyFiveChange} className="form-control" name="dummyFive" value={this.state.dummyFive} required="required" placeholder="Enter Dummy Five" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.dummyFive} </div>
                                    </Row><br />
                                    {/* tableContent */}
                                  </Form>
                                </Row>
                              </Row>
                              <Row>
                                <Col
                                  className="d-flex justify-content-end"
                                  style={{ marginRight: "50px" }}
                                >
                                  <Button
                                    className="button"
                                    variant="success"
                                    onClick={this.AttendeesupdateHandler}
                                    style={{
                                      marginTop: "20px",
                                    }}
                                  >
                                    Update
                                  </Button>
                                </Col>
                              </Row>
                            </Container>
                          </Offcanvas.Body>
                        </Offcanvas>
                      )}
                      {/*offcanvas is over */}
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <div style={{ "marginRight": "5px" }}>
                      {/* searchbar,pagination,filter */}
                      <input
                        type="text"
                        style={{ float: "left", marginBottom: "10px" }}
                        onChange={this.handleFilter}
                        placeholder="Search..."
                      />
                      <DataTable
                        data={paginatedData}
                        columns={this.state.tableClms}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          this.state.filteredData
                            ? this.state.filteredData.length
                            : this.state.data.length
                        }
                        onChangeRowsPerPage={this.handlePerRowsChange}
                        onChangePage={this.handlePageChange}
                        paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
                        paginationPerPage={100}
                        keyField="id"
                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                      />
                    </div>
                  </Row>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    );
  }
}
